import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

interface ValidationTextProps {
    focused?: boolean;
}

export const ValidationText = styled.div<ValidationTextProps>(
    props => ({
        color: theme(props).semanticColors.danger.color,
    }),
    props =>
        props.focused && {
            backgroundColor: theme(props).semanticColors.danger.backgroundColor,
        }
);

export const Gap = styled.span(() => ({
    display: "inline-block",
    marginLeft: 20,
}));
